var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "popstyle", style: { display: _vm.parsedLocalizado } },
      [
        _c(
          "b-modal",
          {
            ref: "myModal",
            staticClass: "fixedModal",
            attrs: {
              size: "lg",
              id: "modal1",
              title: _vm.modalTitle,
              centered: "",
              "hide-footer": true
            },
            on: { hidden: _vm.onHidden }
          },
          [
            _vm.loadingFeatures || _vm.loadingDetails
              ? _c("div", [_c("Loader", { attrs: { delay: 0 } })], 1)
              : _c(
                  "div",
                  [
                    !_vm.details
                      ? [
                          _vm.parsedFeatures.length > 0
                            ? _c(
                                "div",
                                { staticClass: "scroll" },
                                [
                                  _c("b-table", {
                                    attrs: {
                                      striped: "",
                                      hover: "",
                                      items: _vm.parsedFeatures,
                                      fields: _vm.table_fields
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "desc",
                                        fn: function(data) {
                                          return _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(data.item.desc)
                                            }
                                          })
                                        }
                                      },
                                      {
                                        key: "actions",
                                        fn: function(row) {
                                          return [
                                            !row.item.catastro
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showDetails(
                                                          row.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Ver")]
                                                )
                                              : _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "btn btn-secondary",
                                                    attrs: {
                                                      href: row.item.url,
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [_vm._v("Ver")]
                                                )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              )
                            : _c("div", [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.message) +
                                    "\n          "
                                )
                              ])
                        ]
                      : _c(
                          "div",
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _vm.parsedFeatures.length > 1
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "link" },
                                            on: { click: _vm.noDetails }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fa fa-arrow-left",
                                              staticStyle: {
                                                "padding-left": "0em"
                                              }
                                            }),
                                            _vm._v(
                                              "\n                Atrás\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { staticClass: "text-right" },
                                  [
                                    _c(
                                      "b-button",
                                      { on: { click: _vm.localizar } },
                                      [_vm._v("Localizar")]
                                    ),
                                    _vm._v(" "),
                                    _vm.isTerritory && _vm.selectarea
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "ml-4",
                                            on: { click: _vm.selectArea }
                                          },
                                          [_vm._v("Aceptar")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("Details", {
                              ref: "details",
                              attrs: {
                                feature: _vm.details,
                                permisos: _vm.permisos
                              },
                              on: {
                                close: _vm.close,
                                comercialSaved: _vm.comercialSaved,
                                calderaSaved: _vm.calderaSaved
                              }
                            })
                          ],
                          1
                        )
                  ],
                  2
                )
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.localizado
      ? _c(
          "div",
          { staticClass: "absoluteButton" },
          [
            _vm.change
              ? _c("b-button", { on: { click: _vm.saveLocation } }, [
                  _vm._v("Guardar")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("b-button", { on: { click: _vm.atras } }, [_vm._v("Atras")])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/PopUp.vue?vue&type=template&id=0c58e111&
// module id = null
// module chunks = 